import { render, staticRenderFns } from "./retailerTraining.vue?vue&type=template&id=51065316&scoped=true"
import script from "./retailerTraining.vue?vue&type=script&lang=js"
export * from "./retailerTraining.vue?vue&type=script&lang=js"
import style0 from "./retailerTraining.vue?vue&type=style&index=0&id=51065316&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51065316",
  null
  
)

export default component.exports